import { clearStudent } from "../actions/common/student";
import StudentNavi from "../components/features/Navigation/StudentNavi";
import { useNavigationToggle } from "../contexts/NavigationContext";
import { withRouter } from "../helpers/RouterHelper";
import {
  AuthenticatedPageCallbacks,
  AuthenticatedPageProps,
} from "../hocs/enhanceAuthenticatedPage";

export interface SidebarProps
  extends AuthenticatedPageProps,
    AuthenticatedPageCallbacks {
  clearStudent: typeof clearStudent;
  activeMenu: string;
}

const StudentSidebar = (props: SidebarProps) => {
  const { isNavigationOpen } = useNavigationToggle();
  const tagFilter = studentTagFilter(props);
  if (
    !props.currentSection.data ||
    !props.currentOperator ||
    !props.student.data ||
    !props.operatorPrivileges.data ||
    !tagFilter
  ) {
    return null;
  }

  return (
    <StudentNavi
      {...props}
      operatorPrivileges={props.operatorPrivileges.data}
      student={props.student.data}
      section={props.currentSection.data}
      opened={isNavigationOpen}
      tagFilter={tagFilter}
    />
  );
};

const studentTagFilter = (props: SidebarProps) => {
  return props.studentFilterContext.findTagFilter({
    sectionId: props.currentSection?.data?.id || "",
  });
};

export default withRouter<SidebarProps>(StudentSidebar);
